import ProfileImg from '../images/Loader_Logo.png';

export const Profile = ProfileImg;

export const BuildVersion = 'V 1.48';

export const REST_API_END_POINT = "https://mayuravahanam.com/backend/webservice/";
export const REST_API = "https://mayuravahanam.com/backend/";
export const BASE_URL = "https://mayuravahanam.com/";

// export const REST_API_END_POINT = "https://api-mayura.skywhoo.com/webservice/";
// export const REST_API = "https://api-mayura.skywhoo.com/";
// export const BASE_URL = "https://mayura.skywhoo.com/";

// export const REST_API_END_POINT = "http://localhost:4000/webservice/";
// export const REST_API = "http://localhost:4000/";
// export const BASE_URL = "http://localhost:3000/";

// export const REST_API_END_POINT = "https://mj9ct70w-5000.inc1.devtunnels.ms/webservice/";
// export const REST_API = "https://mj9ct70w-5000.inc1.devtunnels.ms/";
// export const BASE_URL = "https://mj9ct70w-3000.inc1.devtunnels.ms/";

